export const CHART_NEAREST_KEY_CHANGE_EVENT = `onNearestKeyChange`;
export const CHART_CLICK_EVENT = `onClick`;
export const CHART_POINTER_MOVE_EVENT = `onPointerMove`;
export const CHART_TOOLTIP_HIDE_EVENT = `onHideTooltip`;
